import type { Dispatch } from "react";
import { createContext } from "react";
import type { DisplayOptionsAction } from "@/pages/human-resources/time-management/model/display-options/DisplayOptionsAction.ts";

export const DisplayOptionsDispatchContext = createContext<
  Dispatch<DisplayOptionsAction> | undefined
>(undefined);
